import React from 'react'
import { CrossIcon } from '@grupoboticario/flora-react-icons'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { forwardRef, styled } from '@grupoboticario/flora-react-system'
import {
  CloseButtonStyles,
  HeaderStyles,
  OverlayStyles,
  BodyStyles,
  FooterStyles,
  TriggerStyles,
} from './styles'

export const Dialog = DialogPrimitive.Root
export const DialogTitle = DialogPrimitive.Title
export const DialogDescription = DialogPrimitive.Description

export type {
  DialogProps,
  DialogTitleProps,
  DialogDescriptionProps,
  DialogTriggerProps,
} from '@radix-ui/react-dialog'

export const DialogTrigger = styled(DialogPrimitive.Trigger, TriggerStyles)
export const DialogFooter = styled('footer', FooterStyles)
export const DialogHeader = styled('header', HeaderStyles)
export const DialogBody = styled('div', BodyStyles)
// styled
const StyledDialogOverlay = styled('div', OverlayStyles)
const StyledDialogClose = styled(DialogPrimitive.Close, CloseButtonStyles)

export type DialogCloseProps = DialogPrimitive.DialogCloseProps

export const DialogClose = forwardRef<'button', DialogCloseProps>(
  ({ children, asChild = false, ...props }, forwardedRef) => {
    if (asChild)
      return (
        <DialogPrimitive.Close aria-label="Fechar" {...props} asChild>
          {children}
        </DialogPrimitive.Close>
      )

    return (
      <StyledDialogClose aria-label="Fechar" {...props} ref={forwardedRef}>
        <CrossIcon color="$linkDefault" />
      </StyledDialogClose>
    )
  },
)

export type DialogContentProps = DialogPrimitive.PortalProps & DialogPrimitive.DialogContentProps

export const DialogContent = forwardRef<'div', DialogContentProps>(
  ({ children, forceMount, container, ...props }, forwardedRef) => {
    return (
      <DialogPrimitive.Portal forceMount={forceMount} container={container}>
        <StyledDialogOverlay data-flora="overlay" />
        <DialogPrimitive.Content {...props} ref={forwardedRef}>
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    )
  },
)
